!function() {
    "use strict";
    /* @preserve
   * https://github.com/Elkfox/Ajaxinate
   * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
   * MIT License (do not remove above copyright!)
   */
    function e(e) {
        const t = e || {};
        this.settings = Object.assign({
            method: "scroll",
            container: "#AjaxinateContainer",
            pagination: "#AjaxinatePagination",
            offset: 0,
            loadingText: "Loading",
            callback: null
        }, t),
        this.addScrollListeners = this.addScrollListeners.bind(this),
        this.addClickListener = this.addClickListener.bind(this),
        this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this),
        this.preventMultipleClicks = this.preventMultipleClicks.bind(this),
        this.removeClickListener = this.removeClickListener.bind(this),
        this.removeScrollListener = this.removeScrollListener.bind(this),
        this.removePaginationElement = this.removePaginationElement.bind(this),
        this.destroy = this.destroy.bind(this),
        this.containerElement = document.querySelector(this.settings.container),
        this.paginationElement = document.querySelector(this.settings.pagination),
        this.initialize()
    }
    e.prototype.initialize = function() {
        if (!this.containerElement)
            return;
        ({
            click: this.addClickListener,
            scroll: this.addScrollListeners
        })[this.settings.method]()
    }
    ,
    e.prototype.addScrollListeners = function() {
        this.paginationElement && (document.addEventListener("scroll", this.checkIfPaginationInView),
        window.addEventListener("resize", this.checkIfPaginationInView),
        window.addEventListener("orientationchange", this.checkIfPaginationInView))
    }
    ,
    e.prototype.addClickListener = function() {
        this.paginationElement && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
        this.clickActive = !0,
        void 0 !== this.nextPageLinkElement && null !== this.nextPageLinkElement && this.nextPageLinkElement.addEventListener("click", this.preventMultipleClicks))
    }
    ,
    e.prototype.preventMultipleClicks = function(e) {
        e.preventDefault(),
        this.clickActive && (this.nextPageLinkElement.innerText = this.settings.loadingText,
        this.nextPageUrl = this.nextPageLinkElement.href,
        this.clickActive = !1,
        this.loadMore())
    }
    ,
    e.prototype.checkIfPaginationInView = function() {
        const e = this.paginationElement.getBoundingClientRect().top - this.settings.offset
          , t = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
        e <= window.innerHeight && t >= 0 && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
        this.removeScrollListener(),
        this.nextPageLinkElement && (this.nextPageLinkElement.innerText = this.settings.loadingText,
        this.nextPageUrl = this.nextPageLinkElement.href,
        this.loadMore()))
    }
    ,
    e.prototype.loadMore = function() {
        this.request = new XMLHttpRequest,
        this.request.onreadystatechange = function() {
            if (!this.request.responseXML)
                return;
            if (4 === !this.request.readyState || 200 === !this.request.status)
                return;
            const e = this.request.responseXML.querySelectorAll(this.settings.container)[0]
              , t = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
            this.containerElement.insertAdjacentHTML("beforeend", e.innerHTML),
            void 0 === t ? this.removePaginationElement() : (this.paginationElement.innerHTML = t.innerHTML,
            this.settings.callback && "function" == typeof this.settings.callback && this.settings.callback(this.request.responseXML),
            this.initialize());
            globoswatch?.init();
        }
        .bind(this),
        this.request.open("GET", this.nextPageUrl),
        this.request.responseType = "document",
        this.request.send()
    }
    ,
    e.prototype.removeClickListener = function() {
        this.nextPageLinkElement.removeEventListener("click", this.preventMultipleClicks)
    }
    ,
    e.prototype.removePaginationElement = function() {
        this.paginationElement.innerHTML = "",
        this.destroy()
    }
    ,
    e.prototype.removeScrollListener = function() {
        document.removeEventListener("scroll", this.checkIfPaginationInView),
        window.removeEventListener("resize", this.checkIfPaginationInView),
        window.removeEventListener("orientationchange", this.checkIfPaginationInView)
    }
    ,
    e.prototype.destroy = function() {
        return {
            click: this.removeClickListener,
            scroll: this.removeScrollListener
        }[this.settings.method](),
        this
    }
    ,
    customElements.get("ajaxinate-items") || customElements.define("ajaxinate-items", class extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.init()
        }
        init() {
            this.endlessScroll = null;
            const t = this?.dataset.ajaxinateId
              , i = `#AjaxinateLoop[data-ajaxinate-id="${t}"]`
              , n = `#AjaxinatePagination[data-ajaxinate-id="${t}"]`;
            this?.children.length > 0 && (this.endlessScroll = new e({
                container: i,
                pagination: n,
                method: "scroll"
            }))
        }
        reinit() {
            this.unload(),
            this.init()
        }
        unload() {
            null !== this.endlessScroll && (this.endlessScroll.settings.method = "scroll",
            this.endlessScroll.destroy(),
            this.endlessScroll = null)
        }
        disconnectedCallback() {
            this.unload()
        }
    }
    )
}();
